<template>
  <div class="main-home-div">
    <b-jumbotron>
      <template slot="header"> MyCHS </template>
      <!-- <template slot="lead"> Student Management </template> -->
      <hr />
      <b-alert :show="user.firstTimeUser"
        >Your account is being created. If you need to submit the CHS Course
        Overrides Form, you may proceed. For other features, please check back
        later.</b-alert
      >
      <div class="mt-2">
        <b-button :to="{ name: 'overrideForm' }" variant="primary"
          >Course Override Form</b-button
        >
        <b-button
          v-if="isStudent()"
          class="ml-2"
          :to="{ name: 'placementsHome' }"
          variant="primary"
          >View placement opportunities</b-button
        >
      </div>
      <!-- <div class="mt-2" v-if="canViewOverrides()">Click <router-link :to="{name: 'overrideDashboard'}">here</router-link> to view the override dashboard.</div> -->
      <div class="mt-2" v-if="isAdminOrAdvisor()">
        To view a student's profile, begin typing their name, ASU email address,
        or Asurite ID in the search bar below.
      </div>
      <b-form-group v-if="isAdminOrAdvisor()" class="home-student-search">
        <autocomplete
          ref="autocomplete"
          :source="apiEndpoint"
          results-property="asuriteId"
          :resultsDisplay="studentDisplay"
          inputClass="form-control"
          @selected="selectStudent"
          credentials="include"
          :request-headers="requestHeaders"
        ></autocomplete>
      </b-form-group>
    </b-jumbotron>
  </div>
</template>

<script>
//import Vue from "vue";
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" },
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),

    apiEndpoint: function () {
      return process.env.VUE_APP_BASE_URI + "/api/Students/FindStudent?query=";
    },
  },

  methods: {
    isStudent: function () {
      return _.find(this.user.userRoles, function (userRole) {
        return userRole === "Student";
      });
    },

    canViewOverrides: function () {
      return _.find(this.user.userRoles, function (userRole) {
        return (
          userRole === "Overrides.Admin" || userRole === "Overrides.Advisor"
        );
      });
    },

    isAdminOrAdvisor: function () {
      return _.find(this.user.userRoles, function (userRole) {
        return (
          userRole === "Overrides.Admin" ||
          userRole === "Overrides.Advisor" ||
          userRole === "Incidents.Admin" ||
          userRole === "Incidents.Faculty" ||
          userRole === "Placements.Advisor" ||
          userRole === "Placements.Admin"
        );
      });
    },

    // formatted display for student selection
    studentDisplay: function (student) {
      return (
        student.asuriteId + " - " + student.firstName + " " + student.lastName
      );
    },

    // when student is selected from list, navigate to their profile page
    selectStudent: function (result) {
      this.$router.push({
        name: "student",
        params: { asuriteId: result.selectedObject.asuriteId },
      });
    },
  },
};
</script>

<style>
.main-home-div {
  padding: 10px;
}

.home-student-search {
  max-width: 500px;
}
</style>
